// extracted by mini-css-extract-plugin
export default {"checkWrapper":"style_checkWrapper__ejhJG","checkInfoWrapper":"style_checkInfoWrapper__AeaSQ","checkInfo":"style_checkInfo__L7eZH"};